export default "__VITE_ASSET__fxvfefW8__"